<template>
  <div v-if="loaded" class="row">
    <!-- Réorganise ton formulaire ici -->
    <mh-input
      mhClass="col-12"
      field="name"
      label="Nom de la localité"
      :table="localities"
    ></mh-input>
    <mh-input
      mhClass="col-12"
      field="contact_name"
      label="Nom du contact"
      :table="localities"
    ></mh-input>
    <mh-input
      mhClass="col-12"
      field="contact_address"
      label="Adresse"
      :table="localities"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="contact_email"
      label="Email"
      :table="localities"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="contact_phone"
      label="Téléphone"
      :table="localities"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="contact_bank"
      label="N° de compte"
      :table="localities"
      prepend="BE"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="search_cost"
      label="Coût de la recherche"
      :table="localities"
      type="number"
      append="€"
    ></mh-input>
    <b-col lg="12">
      <b-form-group
        class="my-0"
        label="Codes postaux"
        label-size="sm"
        label-class="mb-0"
        label-for="tags-pc"
      >
        <b-form-tags
          input-id="tags-pc"
          v-model="localities.postal_code.value"
          placeholder="Entrez de nouveaux codes postaux séparés par un espace"
          no-add-on-enter
          tag-variant="info"
          tag-pills
          remove-on-delete
          :tag-validator="pcValidator"
          size="lg"
          separator=" "
        ></b-form-tags>
      </b-form-group>
    </b-col>

    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import localities from "@/services/localities";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Locality",
  components: {
    MhInput,
  },
  props: {
    localities_id: [Number, String],
  },
  
  data() {
    return {
      localities: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    pcValidator(pc) {
      return pc.match(/^\d{4}$/)
    },
    load() {
      localities
        .localities({
          localities_id: this.localities_id,
        })
        .then((response) => {
          this.localities = response.data;
          this.loaded = true;
        });
    },

    save() {
      localities
        .update_localities({
          localities_id: this.localities_id,
          localities: this.localities,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Localité mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.localities) {
              if (this.localities[el]) {
                this.localities[el].error = false;
              }
            }
            this.$emit("change");
            this.$emit("close");
          } else if (response.data.fail) {
            for (let el in this.localities) {
              if (this.localities[el]) {
                this.localities[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.localities[element.field].error = element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>